import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { UiStore } from '@pt/services';
import { ButtonModule } from '@hglobal/common';
import { environment } from '@pt/environment';

@Component({
  selector: 'pt-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, RouterLink, ButtonModule],
})
export class NotFoundComponent {
  readonly uiStore = inject(UiStore);
  readonly isHexagonalDesign = environment.shortName === 'pt';
  readonly extention = this.isHexagonalDesign ? 'png' : 'svg';
  readonly folderName = this.isHexagonalDesign ? 'app-images/404/' : '404/';
}
